import { Pencil } from "@reverb-ui/icons-react";
import { Badge, Flex, IconButton, Tooltip } from "@reverb-ui/react";

interface IFilterBadgeProps {
  index: number;
  children: React.ReactNode;
  maxWidthText?: number | string;
  onClickEditIcon?: () => void;
}

export const FilterBadge: React.FC<IFilterBadgeProps> = ({
  index,
  children,
  maxWidthText,
  onClickEditIcon,
}) => {
  return (
    <Tooltip label={children} bg="gray.100" color="gray.800">
      <span style={{ fontSize: "var(--chakra-fontSizes-xs)" }}>
        <Badge
          key={index}
          textTransform="none"
          background={index === 0 ? "highlight.100" : "warning.100"}
          color={index === 0 ? "highlight.800" : "warning.800"}
          onClick={() => onClickEditIcon?.()}
          cursor="pointer"
        >
          <Flex gap="2px" alignItems="center">
            <span
              style={{
                maxWidth: maxWidthText,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {children}
            </span>
            {onClickEditIcon && (
              <IconButton
                aria-label="icon-button-edit"
                icon={
                  <Pencil
                    color={index === 0 ? "highlight.800" : "warning.800"}
                  />
                }
                height="100%"
                minW="none"
                background={index === 0 ? "highlight.100" : "warning.100"}
                width="13px"
                onClick={onClickEditIcon}
              />
            )}
          </Flex>
        </Badge>
      </span>
    </Tooltip>
  );
};

export default FilterBadge;
